import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { frontloadConnect } from "react-frontload";
import { isResourceReadable, loadResourceGroupPermissions } from "../actions";
import * as Resources from "../resources";

const frontload = async (props) => {
  await props.getResourceGroupPermissions("News");
};

const mapStateToProps = (state) => {
  return {
    loading: state.permissions.loadingGroup["news"],
    permissions: state.permissions.permissionGroup["news"],
  };
};

const mapDispatchToProps = (dispatch) => ({
  getResourceGroupPermissions: (...args) =>
    dispatch(loadResourceGroupPermissions(...args)),
});

// News Manager Redirect
function NewsServiceRedirect({ loading, permissions }) {
  // console.log("NewsServiceRedirect()", loading, permissions);
  if (loading === undefined || loading === true || permissions === undefined || Object.keys(permissions).length === 0) {
    return null;
  }

  const showMessagePanel = isResourceReadable(
    Resources.News.MessagePanel,
    permissions,
  );
  const showArticles = isResourceReadable(Resources.News.Articles, permissions);
  const showProtocols = isResourceReadable(
    Resources.News.Protocols,
    permissions,
  );

  let targetUrl = "/news-service/archiv";
  if (showMessagePanel) {
    targetUrl = "/news-service/nachrichten";
  } else if (showProtocols) {
    targetUrl = "/news-service/protokolle";
  } else if (showArticles) {
    targetUrl = "/news-service/beitraege";
  }
  return <Redirect to={targetUrl} />;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(NewsServiceRedirect),
);
